import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
      userName: '',
      isAdmin: false,
      logoutTimer: null
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    loginAsAdmin(token) {
      this.isAdmin = true
      const expiresIn = 30 * 60 * 1000 // 30 минут
      const expiresAt = new Date().getTime() + expiresIn
      
      localStorage.setItem('adminToken', token)
      localStorage.setItem('adminExpires', expiresAt.toString())
      
      this.startLogoutTimer(expiresIn)
    },
    logoutAdmin() {
      this.isAdmin = false
      this.userName = ''
      localStorage.removeItem('adminToken')
      localStorage.removeItem('adminExpires')
      if (this.logoutTimer) clearTimeout(this.logoutTimer)
    },
    checkAuth() {
      const token = localStorage.getItem('adminToken')
      const expires = localStorage.getItem('adminExpires')
      
      if (token && expires && new Date().getTime() < parseInt(expires)) {
        this.isAdmin = true
        this.startLogoutTimer(parseInt(expires) - new Date().getTime())
        return true
      }
      return false
    },
    startLogoutTimer(duration) {
      if (this.logoutTimer) clearTimeout(this.logoutTimer)
      this.logoutTimer = setTimeout(() => {
        this.logoutAdmin()
      }, duration)
    },
    resetLogoutTimer() {
      const expires = localStorage.getItem('adminExpires')
      if (expires) {
        this.startLogoutTimer(parseInt(expires) - new Date().getTime())
      }
    },
  },
})
